const SWIPER_RETRY_LIMIT = 20;

initSlidingContent();

document.addEventListener("shopify:section:load", () => initSlidingContent());

function getNumber(value, fallback) {
  const number = Number(value);

  return Number.isFinite(number) ? number : fallback;
}

function clamp(number, min, max) {
  return Math.min(Math.max(number, min), max);
}

function initSlidingContent(retries = SWIPER_RETRY_LIMIT) {
  const carousels = document.querySelectorAll("[data-sliding-content-swiper]");
  if (!carousels.length) return;

  if (!window.Swiper) {
    if (retries > 0) {
      window.setTimeout(() => initSlidingContent(retries - 1), 100);
    }

    return;
  }

  carousels.forEach((carousel) => {
    if (carousel.dataset.initialized === "true") return;

    const parent = carousel.closest(".c-sliding-content__carousel-wrap");
    const prevEl = parent?.querySelector("[data-sliding-content-prev]") || null;
    const nextEl = parent?.querySelector("[data-sliding-content-next]") || null;
    const slideCount = carousel.querySelectorAll(".swiper-slide").length;

    if (!slideCount) return;

    carousel.dataset.initialized = "true";

    const mobileSlides = clamp(getNumber(carousel.dataset.mobile, 1.2), 1, 2);
    const desktopSlides = clamp(getNumber(carousel.dataset.desktop, 3), 1, 5);
    const mobileGap = clamp(getNumber(carousel.dataset.gapMobile, 12), 0, 80);
    const desktopGap = clamp(
      getNumber(carousel.dataset.gapDesktop, 24),
      0,
      100
    );

    new window.Swiper(carousel, {
      slidesPerView: mobileSlides,
      spaceBetween: mobileGap,
      watchOverflow: true,
      speed: 500,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl,
        nextEl,
      },
      breakpoints: {
        768: {
          slidesPerView: desktopSlides,
          spaceBetween: desktopGap,
        },
      },
    });
  });
}
